export enum FreezerModeType {
  CONTINUOUS,
  START_STOP,
  CYCLE_SENTRY
}
